import React from "react";
import classNames from "classnames";

import { Folder as F, Identifiable } from "@planzone/dto";
import { FolderIcon as ProjectIcon } from "@common/folderIcon";
import { FolderIcon } from "./folderIcon";
import { Logo } from "./logo";
import { Props } from "./types";
import styles from "./styles.scss";

function Folder({
  depth = 1,
  folder,
  selectedFolder,
  projectName,
  type,
  select,
}: Props) {
  const isSelected = selectedFolder && selectedFolder.uuid === folder.uuid;

  return (
    <div className={styles.folder}>
      {folder.name.length ? (
        <div
          className={classNames(styles.name, { [styles.selected]: isSelected })}
          style={{ paddingLeft: `${1 * depth}rem` }}
          onClick={() => select(isSelected ? null : folder)}
        >
          <FolderIcon className={styles.folderIcon} />
          <p>{folder.name}</p>
        </div>
      ) : (
        <div
          className={classNames(styles.name, { [styles.selected]: isSelected })}
          style={{ paddingLeft: `${1 * depth}rem` }}
          onClick={() =>
            select(isSelected ? null : { ...folder, name: projectName })
          }
        >
          {type === "project" ? (
            <ProjectIcon className={styles.projectIcon} isOpen />
          ) : (
            <Logo />
          )}
          <p>{projectName}</p>
        </div>
      )}
      {folder.children
        .filter(({ type }) => type === "folder")
        .map((child, key) => (
          <Folder
            folder={child as Identifiable<F>}
            selectedFolder={selectedFolder}
            select={select}
            depth={depth + 1}
            projectName={projectName}
            type={type}
            key={key}
          />
        ))}
    </div>
  );
}

export { Folder };
